import React from "react";
import { useScenarios } from "../../hooks/useScenarios";
import { useTerminology } from "../../hooks/useTerminology";
import { Badge } from "../ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

export const DependencyGraph: React.FC = () => {
  const { scenarios } = useScenarios();
  const { getScenarioTerm } = useTerminology();

  const scenariosWithDeps = scenarios.filter((s) => {
    if (!s.dependencies) return false;
    if (Array.isArray(s.dependencies)) return s.dependencies.length > 0;
    return (
      (s.dependencies.prerequisites?.length || 0) > 0 ||
      (s.dependencies.conflicts?.length || 0) > 0
    );
  });

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>{getScenarioTerm(true)} Dependencies</CardTitle>
        </CardHeader>
        <CardContent>
          {scenariosWithDeps.length === 0 ? (
            <div className="text-center text-muted-foreground py-8">
              No dependencies defined
            </div>
          ) : (
            <div className="space-y-6">
              {scenariosWithDeps.map((scenario) => (
                <div key={scenario.id} className="p-4 border rounded-lg">
                  <div className="font-semibold mb-3">{scenario.name}</div>
                  <div className="space-y-2">
                    {Array.isArray(scenario.dependencies) &&
                      scenario.dependencies.map((dep: any) => {
                        const targetScenario = scenarios.find(
                          (s) => s.id === dep.targetScenarioId,
                        );
                        return (
                          <div
                            key={dep.id}
                            className="flex items-center gap-3 p-3 bg-muted rounded-lg"
                          >
                            <Badge
                              variant={
                                dep.type === "prerequisite"
                                  ? "default"
                                  : dep.type === "conflict"
                                    ? "destructive"
                                    : dep.type === "enables"
                                      ? "secondary"
                                      : "outline"
                              }
                            >
                              {dep.type}
                            </Badge>
                            <div className="flex-1">
                              <div className="font-medium">
                                {targetScenario?.name || "Unknown"}
                              </div>
                              {dep.condition && (
                                <div className="text-xs text-muted-foreground">
                                  Requires: {dep.condition.metric}{" "}
                                  {dep.condition.operator} {dep.condition.value}
                                </div>
                              )}
                            </div>
                            {dep.isMet !== undefined && (
                              <Badge
                                variant={dep.isMet ? "default" : "destructive"}
                              >
                                {dep.isMet ? "Met" : "Unmet"}
                              </Badge>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
